
import type {RoleManagerProps} from '@touchnet/user-management';

import {
    getFinalErpAdminScopes,
} from '~/utils/urps-utils';
import ErpUiAdminDetails from "~/components/pages/user-mgmt/roles/role-details/erp-ui-admin-details";
import ErpAdminScopesDisplay from "~/components/pages/user-mgmt/roles/role-details/erp-admin-scopes-display";
import ErpAdminScopesProvider from "~/components/pages/user-mgmt/providers/erp-admin-scopes-provider";


export const useRoleManagerConfig = (): Pick<RoleManagerProps, 'roles'> => {

    const roles = {

        ERP_UI_ADMIN_USER: {
            code: 'ERP_UI_ADMIN_USER',
            getFinalPlaceholders: getFinalErpAdminScopes,
            name: 'ERP Admin',
            DetailsProvider: ErpUiAdminDetails,
            ScopesDisplay: ErpAdminScopesDisplay,
            ScopesProvider: ErpAdminScopesProvider,
        },
    };

    return {roles};
};

export default useRoleManagerConfig;
